import React from "react";
import { Controller } from "react-hook-form";
import { TextField, FormControl } from "@mui/material";
import { buildValidationRules, getReadOnlyStyles, HELPER_TEXT_STYLES } from "../fieldHelpers";

const TextFieldRenderer = ({ field, control }) => {
    const {
        name,
        label,
        type = "text",
        placeholder = "",
        required = false,
        multiline = false,
        rows = 1,
        fullWidth = true,
        disabled = false,
        readOnly = false,
        numericOnly = false,
        inputMode = "text",
        pattern,
        onChange: externalOnChange,
        error: externalError,
        helperText: externalHelperText,
    } = field;

    const rules = buildValidationRules(field);

    return (
        <Controller
            key={name}
            name={name}
            control={control}
            rules={rules}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const hasExternalError = Boolean(externalError);
                const hasRHFError = Boolean(error);

                const showError = hasExternalError || hasRHFError;
                const helperText = (externalHelperText || error?.message || "").toString();

                return (
                    <FormControl fullWidth={fullWidth} required={required} disabled={disabled} error={showError}>
                        <TextField
                            fullWidth={fullWidth}
                            label={label}
                            type={type}
                            value={value || ""}
                            onChange={(e) => {
                                let newValue = e.target.value;

                                if (numericOnly) {
                                    newValue = newValue.replace(/[^0-9]/g, "");
                                }

                                // React Hook Form update
                                onChange(newValue);

                                // Sync to external reducer state if provided
                                if (typeof externalOnChange === "function") {
                                    externalOnChange(newValue);
                                }
                            }}
                            placeholder={placeholder}
                            multiline={multiline}
                            rows={multiline ? rows : 1}
                            disabled={disabled}
                            error={showError}
                            required={required}
                            InputProps={{
                                readOnly: readOnly,
                                sx: getReadOnlyStyles(readOnly),
                            }}
                            inputProps={{
                                inputMode: inputMode,
                                pattern: pattern,
                            }}
                            FormHelperTextProps={{
                                sx: HELPER_TEXT_STYLES,
                            }}
                            helperText={helperText}
                        />
                    </FormControl>
                );
            }}
        />
    );
};

export default TextFieldRenderer;
